const urlAPI_Dev = "http://localhost:3000/api";
const urlAPI_Prod = "https://www.evoktm.com.br/api";
const urlAPI_Homolog = "https://www.evoktm.com.br/homologacao_api";

const urlAPI_Current = urlAPI_Prod;

export { urlAPI_Current };
